let pauseCount = 0;
let pausedPromise: Promise<void> | null = null;
let resolvePausedPromise: (() => void) | null = null;

export const pauseAuthenticatedRequests = (): (() => void) => {
  if (!pausedPromise) {
    pausedPromise = new Promise<void>((resolve) => {
      resolvePausedPromise = resolve;
    });
  }
  pauseCount += 1;

  let released = false;
  return () => {
    if (released) {
      return;
    }
    released = true;
    pauseCount -= 1;
    if (pauseCount === 0) {
      const resolve = resolvePausedPromise;
      pausedPromise = null;
      resolvePausedPromise = null;
      resolve?.();
    }
  };
};

export const waitForAuthenticatedRequestsToResume = () => pausedPromise ?? Promise.resolve();
